/* SUMONE GA4 interactions. Reuses the Google & YouTube tag; never configures a tag. */
(() => {
  'use strict';
  if (window.sumoneGa4InteractionsLoaded) return;
  window.sumoneGa4InteractionsLoaded = true;

  const config = document.getElementById('sumone-ga4-context');
  if (!config) return;
  const context = config.dataset;
  const pendingSections = new Set();
  let previousVariant = context.variantId || '';

  function send(name, parameters) {
    try {
      const privacy = window.Shopify?.customerPrivacy;
      if (!privacy || privacy.analyticsProcessingAllowed() !== true) return false;
      const parametersWithDestination = { ...parameters, send_to: 'G-PEQ1MEMETG' };
      if (typeof window.gtag === 'function') {
        window.gtag('event', name, parametersWithDestination);
        return true;
      } else if (window.dataLayer && typeof window.dataLayer.push === 'function') {
        // Google tag commands use an Arguments object, not GTM custom-event objects.
        (function () { window.dataLayer.push(arguments); })('event', name, parametersWithDestination);
        return true;
      }
    } catch (_) {
      // Measurement must never interrupt shopping when integrations are unavailable.
    }
    return false;
  }

  function trackInformation(event) {
    if (!event.isTrusted || !context.productId) return;
    const summary = event.target.closest?.('accordion-default summary');
    const details = summary?.closest('details');
    if (!details || details.hasAttribute('open')) return;
    // Wait for the theme's own click handler to confirm the section actually opened.
    setTimeout(() => {
      if (!details.hasAttribute('open') || summary.getAttribute('aria-expanded') !== 'true') return;
      const label = summary.textContent.trim().replace(/\s+/g, ' ').slice(0, 100);
      if (!label) return;
      send('product_info_opened', {
        product_id: context.productId,
        product_name: context.productName.slice(0, 100),
        info_section: label
      });
    }, 0);
  }

  function initialize() {
    if (!window.Shopify?.customerPrivacy && typeof window.Shopify?.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => {});
    }
    document.addEventListener('click', trackInformation, true);
    document.addEventListener('change', event => {
      if (!event.isTrusted || !context.productId) return;
      const picker = event.target.closest?.('product-variant-selects');
      const product = picker?.closest('product-info');
      if (product?.dataset.section) pendingSections.add(product.dataset.section);
    }, true);

    if (typeof subscribe === 'function') {
      subscribe('variant-change', message => {
        const data = message?.data;
        if (!data || !pendingSections.has(data.sectionId)) return;
        pendingSections.delete(data.sectionId);
        const variant = data.variant;
        if (!variant?.id || String(variant.id) === previousVariant) return;
        previousVariant = String(variant.id);
        send('variant_selected', {
          product_id: context.productId,
          product_name: context.productName.slice(0, 100),
          variant_id: String(variant.id),
          selected_variant: String(variant.title).slice(0, 100)
        });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
